import WizardInput from 'componentes/wizard/WizardInput';
import { useAuth } from 'context/AuthProvider';
import { ApiEndpoint } from 'helpers/ApiEndPoint';
import { httpClient } from 'helpers/HttpClient';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import AutocompleteDropdown from 'componentes/generic/AutoComplete';
import { isNullOrEmpty } from 'helpers/utils';

const URIOperations = ApiEndpoint + 'operations/';
const URIConfig = ApiEndpoint + 'configuration/';
const URIAdmin = ApiEndpoint + 'administration/';
const EditProductoData = ({
  idQueja,
  queja,
  setErrorMesagge,
  setShowErrorMessage,
  setIsError,
  closeModal
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tiposProducto, setTiposProducto] = useState(null);
  const [tiposPlataforma, setTiposPlataforma] = useState(null);
  const [statusFacturacion, setStatusFacturacion] = useState(null);
  const [selectedTipoProductoDescription, setSelectedTipoProductoDescription] =
    useState('');
  const [clasificacionesQueja, setClasificacionesQueja] = useState(null);
  const [clasificacionesQuejaWm, setClasificacionesQuejaWm] = useState(null);
  const [clasificacionesQuejaProfeco, setClasificacionesQuejaProfeco] =
    useState(null);

  const [tiposEvento, setTiposEvento] = useState(null);
  const [formatosQueja, setFormatosQueja] = useState(null);
  const {
    formState: { errors },
    control,
    register,
    handleSubmit,
    setValue
  } = useForm({
    defaultValues: {
      numeropedido: '',
      montopagado: 0,
      montoreal: 0,
      tipoplataforma: 0,
      idstatusfacturacion: 0,
      idtipoproducto: 0,
      idtipoevento: 0,
      idclasificacionqueja: 0,
      idclasificacionquejawm: 0,
      idclasificacionquejaprofeco: 0
    }
  });

  const getQuejaProducto = async () => {
    if (queja) {
      console.log('queja', queja);
      setValue('numeropedido', queja.numeropedido);
      setValue('montopagado', queja.montopagado);
      setValue('montoreal', queja.montoreal);
      setValue('tipoplataforma', queja.tipoplataforma);
      setValue('idtipoevento', queja.idtipoevento);
      setValue('idstatusfacturacion', queja.idstatusfacturacion);
      setValue('idtipoproducto', queja.idtipoproducto);
      setValue('idclasificacionqueja', queja.idclasificacionqueja);
      setValue('idclasificacionquejawm', queja.idclasificacionquejawm);
      setValue(
        'idclasificacionquejaprofeco',
        queja.idclasificacionquejaprofeco
      );
      setSelectedTipoProductoDescription(queja.tipoproductoqueja.descripcion);
    }
  };

  const onSubmit = data => {
    console.log(data);
    httpClient(
      'POST',
      URIOperations + 'updateProductoData/' + idQueja,
      { data },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          closeModal();
          setIsError(false);
          setErrorMesagge('Expediente Actualizado con exito');
          setShowErrorMessage(true);
        } else {
          setIsError(true);
          setErrorMesagge('Ha ocurrido un error al registrar el cierre');
          setShowErrorMessage(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsError(true);
        setErrorMesagge('Ha ocurrido un error al registrar el cierre');
        setShowErrorMessage(true);
      })
      .finally(() => {});
  };
  const getTiposProducto = async () => {
    setTiposProducto(null);

    httpClient('GET', URIConfig + 'tiposproducto/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return { id: item.idtipoproducto, description: item.descripcion };
          });
          setTiposProducto(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getTiposPlataforma = async () => {
    setTiposPlataforma(null);

    httpClient('GET', URIConfig + 'tiposplataforma/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return { value: item.idplataforma, label: item.plataforma };
          });
          setTiposPlataforma(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getStatusFacturacion = async () => {
    setStatusFacturacion(null);

    httpClient('GET', URIConfig + 'statusbytype/' + 7, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data.map(item => {
            return { value: item.idstatus, label: item.descripcion };
          });
          setStatusFacturacion(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getClasificacionesQuejaWm = async () => {
    setClasificacionesQuejaWm(null);

    httpClient('GET', URIAdmin + 'clasificationswm/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return {
              value: item.idclasificacionquejawm,
              label: `${item.clave}/${item.descripcion}`
            };
          });
          setClasificacionesQuejaWm(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getClasificacionesQueja = async () => {
    setClasificacionesQueja(null);

    httpClient('GET', URIAdmin + 'clasifications/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return {
              value: item.idclasificacionqueja,
              label: `${item.clave}/${item.descripcion}`
            };
          });
          setClasificacionesQueja(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getClasificacionesQuejaProfeco = async () => {
    setClasificacionesQuejaProfeco(null);

    httpClient('GET', URIAdmin + 'clasificationsprofeco/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var clasificaciones = response.data.map(item => {
            return {
              value: item.idclasificacionquejaprofeco,
              label: `${item.descripcion}`
            };
          });
          setClasificacionesQuejaProfeco(clasificaciones);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getFormatosQueja = async () => {
    setFormatosQueja(null);

    httpClient('GET', URIAdmin + 'formatosqueja/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var tiposPlataforma = response.data.map(item => {
            return { value: item.idformatoqueja, label: item.formato };
          });
          setFormatosQueja(tiposPlataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getTiposEventos = async () => {
    setTiposEvento(null);

    httpClient('GET', URIConfig + 'eventtypes/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var tiposPlataforma = response.data.map(item => {
            return { value: item.idtipoeventos, label: item.descripcion };
          });
          setTiposEvento(tiposPlataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    if (!tiposProducto) getTiposProducto();
    if (!statusFacturacion) getStatusFacturacion();
    if (!tiposPlataforma) getTiposPlataforma();
    if (!clasificacionesQuejaWm) getClasificacionesQuejaWm();
    if (!clasificacionesQueja) getClasificacionesQueja();
    if (!tiposEvento) getTiposEventos();
    if (!formatosQueja) getFormatosQueja();
    if (!clasificacionesQuejaProfeco) getClasificacionesQuejaProfeco();
    getQuejaProducto();
  }, []);
  return (
    <>
      <Card>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-2 mb-3">
              <Col>
                <Controller
                  name="numeropedido"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Numero de Pedido</Form.Label>
                      <Form.Control
                        type={'text'}
                        placeholder={'numeropedido'}
                        name="numeropedido"
                        {...field}
                        isInvalid={!!errors.numeropedido}
                        isValid={
                          Object.keys(errors).length > 0 && !errors.numeropedido
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.numeropedido?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                />
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {' '}
                <WizardInput
                  label="Monto Pagado"
                  name="montopagado"
                  errors={errors}
                  type="number"
                  formGroupProps={{ className: 'mb-3' }}
                  formControlProps={{
                    ...register('montopagado', { required: true })
                  }}
                />
              </Col>
              <Col>
                <WizardInput
                  label="Monto Real"
                  name="montoreal"
                  type="number"
                  errors={errors}
                  formGroupProps={{ className: 'mb-3' }}
                  formControlProps={{
                    ...register('montoreal', { required: true })
                  }}
                />
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {tiposPlataforma && (
                  <WizardInput
                    label="Tipo de Plataforma"
                    name="tipoplataforma"
                    type="select"
                    errors={errors}
                    options={tiposPlataforma}
                    formGroupProps={{ className: 'mb-3' }}
                    formControlProps={{
                      ...register('tipoplataforma', { required: true })
                    }}
                  />
                )}
              </Col>
              <Col>
                {statusFacturacion && (
                  <WizardInput
                    label="Status Facturacion"
                    name="idstatusfacturacion"
                    type="select"
                    errors={errors}
                    options={statusFacturacion}
                    formGroupProps={{ className: 'mb-3' }}
                    formControlProps={{
                      ...register('idstatusfacturacion', { required: true })
                    }}
                  />
                )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {tiposProducto &&
                  tiposProducto.length > 0 &&
                  !isNullOrEmpty(selectedTipoProductoDescription) && (
                    <>
                      <AutocompleteDropdown
                        items={tiposProducto}
                        placeholder="Selecciona un tipo de Producto"
                        currentSelected={selectedTipoProductoDescription}
                        register={register}
                        name="idtipoproducto"
                        setValue={setValue}
                        errors={errors}
                        addButton={false}
                        setCurrentSelected={value => {
                          setSelectedTipoProductoDescription(value.description);
                          // setIdSubCustomer(value.id);
                        }}
                        // setSelected={value => {
                        //   setSelectedTipoProductoDescription(value);
                        //   setValue('tipoproducto', value, {
                        //     shouldValidate: true
                        //   });
                        // }}
                      />
                    </>
                  )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {tiposEvento && (
                  <WizardInput
                    label="Tipos de Evento"
                    name="idtipoevento"
                    type="select"
                    errors={errors}
                    options={tiposEvento}
                    formGroupProps={{ className: 'mb-3' }}
                    formControlProps={{
                      ...register('idtipoevento', { required: true })
                    }}
                  />
                )}
              </Col>
              <Col>
                {clasificacionesQuejaWm && (
                  <WizardInput
                    label="Clasificaciones Queja Walmart"
                    name="idclasificacionquejawm"
                    type="select"
                    errors={errors}
                    options={clasificacionesQuejaWm}
                    formGroupProps={{ className: 'mb-3' }}
                    formControlProps={{
                      ...register('idclasificacionquejawm', { required: true })
                    }}
                  />
                )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {clasificacionesQueja && (
                  <WizardInput
                    label="Clasificacion Queja "
                    name="idclasificacionqueja"
                    type="select"
                    errors={errors}
                    options={clasificacionesQueja}
                    formGroupProps={{ className: 'mb-3' }}
                    formControlProps={{
                      ...register('idclasificacionqueja', {
                        required: true
                      })
                    }}
                  />
                )}
              </Col>
              <Col>
                {clasificacionesQuejaProfeco && (
                  <WizardInput
                    label="Clasificacion Queja Profeco"
                    name="idclasificacionquejaprofeco"
                    type="select"
                    errors={errors}
                    options={clasificacionesQuejaProfeco}
                    formGroupProps={{ className: 'mb-3' }}
                    formControlProps={{
                      ...register('idclasificacionquejaprofeco', {
                        required: true
                      })
                    }}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
EditProductoData.propTypes = {
  idQueja: PropTypes.number.isRequired,
  queja: PropTypes.object,
  closeModal: PropTypes.func,
  setErrorMesagge: PropTypes.func,
  setShowErrorMessage: PropTypes.func,
  setIsError: PropTypes.func
};
export default EditProductoData;
